module.exports = __webpack_public_path__ + "static/tek-ff96cdca6692f3533832a7d5e8d42ca5.jpg";